import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "@babel/runtime/helpers/esm/toArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { compose } from 'recompose';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Popover, PopoverBody } from 'reactstrap';
import classNames from 'classnames';
import { ContentEditable } from '../common/ContentEditable';
import { connect } from '../../store';
import { bundle } from '../../helpers';
import { SEND_MESSAGE_UPDATE, SEND_MESSAGE } from './redux';
var VALID_IMG_TYPES = ['image/jpeg', 'image/bmp', 'image/gif', 'image/x-icon', 'image/png', 'image/svg+xml'];

var canShowPreview = function canShowPreview(attachment) {
  return attachment.preview && VALID_IMG_TYPES.includes(attachment.type) || attachment.value && VALID_IMG_TYPES.includes(attachment.value.contentType);
};

var getThumbnailUrl = function getThumbnailUrl(discussion, message, attachment) {
  return "".concat(bundle.spaceLocation(), "/app/discussions/api/v1/discussions/").concat(discussion.id, "/messages/").concat(message.id, "/files/").concat(attachment.value.thumbnailId, "/").concat(encodeURIComponent(attachment.value.filename.replace(/ /g, '_')));
};

var getThumbnailSrc = function getThumbnailSrc(discussion, message, attachment) {
  return canShowPreview(attachment) ? attachment.type === 'attachment' ? getThumbnailUrl(discussion, message, attachment) : attachment.preview : null;
};

var UploadCard = function UploadCard(_ref) {
  var discussion = _ref.discussion,
      message = _ref.message,
      attachment = _ref.attachment,
      remove = _ref.remove;
  var name = attachment.value ? attachment.value.filename : attachment.name;
  var thumbnailSrc = getThumbnailSrc(discussion, message, attachment);
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-wrapper",
    style: {
      display: 'flex',
      backgroundColor: '#fff',
      height: '24px',
      minWidth: '96px',
      maxWidth: '182px',
      color: '#54698D',
      fontSize: '10px',
      lineHeight: '12px',
      marginBottom: '0.5em',
      marginRight: '0.5em'
    }
  }, thumbnailSrc && /*#__PURE__*/React.createElement("img", {
    src: thumbnailSrc,
    alt: name,
    style: {
      width: '24px',
      height: '24px'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: '1',
      marginLeft: '0.5em'
    }
  }, name), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-icon",
    type: "button",
    style: {
      width: '24px',
      height: '24px',
      display: 'flex',
      justifyContent: 'center'
    },
    onClick: remove(attachment),
    "aria-label": "Remove file from message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-fw fa-times"
  })));
};

var ChatInput = /*#__PURE__*/function (_Component) {
  _inherits(ChatInput, _Component);

  var _super = _createSuper(ChatInput);

  function ChatInput(props) {
    var _this;

    _classCallCheck(this, ChatInput);

    _this = _super.call(this, props);

    _this.handleAttachmentCancel = function (attachment) {
      return function (_e) {
        _this.setState({
          fileAttachments: _this.state.fileAttachments.filter(function (a) {
            return a !== attachment;
          })
        });
      };
    };

    _this.handleFocus = function () {
      _this.setState({
        hasFocus: true
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        hasFocus: false
      });
    };

    _this.state = {
      chatInput: '',
      actionsOpen: false,
      fileAttachments: [],
      hasFocus: false
    };
    _this.handleSendChatMessage = _this.handleSendChatMessage.bind(_assertThisInitialized(_this));
    _this.handleChatHotKey = _this.handleChatHotKey.bind(_assertThisInitialized(_this));
    _this.handleChatInput = _this.handleChatInput.bind(_assertThisInitialized(_this));
    _this.handleAttachmentDrop = _this.handleAttachmentDrop.bind(_assertThisInitialized(_this));
    _this.handleAttachmentClick = _this.handleAttachmentClick.bind(_assertThisInitialized(_this));
    _this.handleImagePaste = _this.handleImagePaste.bind(_assertThisInitialized(_this));
    _this.handleDropzoneRef = _this.handleDropzoneRef.bind(_assertThisInitialized(_this));
    _this.isChatInputInvalid = _this.isChatInputInvalid.bind(_assertThisInitialized(_this));
    _this.toggleActionsOpen = _this.toggleActionsOpen.bind(_assertThisInitialized(_this));
    _this.setActionsOpen = _this.setActionsOpen.bind(_assertThisInitialized(_this));
    _this.cancelAction = _this.cancelAction.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ChatInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.registerChatInput(this);
    }
  }, {
    key: "handleSendChatMessage",
    value: function handleSendChatMessage(e) {
      e.preventDefault();

      if (this.props.messageActions.editing) {
        this.props.messageActions.edit(null);
        this.props.dispatch({
          type: SEND_MESSAGE_UPDATE,
          payload: {
            discussionId: this.props.discussion.id,
            id: this.props.messageActions.editing.id,
            message: this.state.chatInput,
            attachment: this.state.fileAttachments
          }
        });
      } else {
        this.props.dispatch({
          type: SEND_MESSAGE,
          payload: {
            id: this.props.discussion.id,
            message: this.state.chatInput,
            attachment: this.state.fileAttachments,
            parentId: this.props.messageActions.replying && this.props.messageActions.replying.id
          }
        });

        if (this.props.messageActions.replying) {
          this.props.messageActions.reply(null);
        }
      }

      this.setState({
        chatInput: '',
        fileAttachments: []
      });
    }
  }, {
    key: "handleChatHotKey",
    value: function handleChatHotKey(_ref2) {
      var e = _ref2.nativeEvent;

      if (e.keyCode === 13 && !e.shiftKey && (this.state.chatInput.trim().length > 0 || this.state.fileAttachments.length > 0)) {
        // Handle enter (but not shift enter.)
        this.handleSendChatMessage(e);
      } else if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
      }
    }
  }, {
    key: "handleChatInput",
    value: function handleChatInput(event, value) {
      this.setState({
        chatInput: value
      });
    }
  }, {
    key: "editMessage",
    value: function editMessage(message) {
      var _message$content = _toArray(message.content),
          textToken = _message$content[0],
          attachmentTokens = _message$content.slice(1);

      this.setState({
        chatInput: textToken.value,
        fileAttachments: attachmentTokens
      });
      this.contentEditable.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.contentEditable.focus();
    }
  }, {
    key: "cancelAction",
    value: function cancelAction() {
      this.props.messageActions.edit(null);
      this.props.messageActions.reply(null);
      this.setState({
        chatInput: '',
        fileAttachments: []
      });
    }
  }, {
    key: "handleAttachmentDrop",
    value: function handleAttachmentDrop(files) {
      var _this2 = this;

      var notAlreadyAttached = files.filter(function (file) {
        return !_this2.state.fileAttachments.find(function (fa) {
          return fa.name === file.name;
        });
      }); // Store the dropped/selected file.

      this.setState({
        fileAttachments: this.state.fileAttachments.concat(notAlreadyAttached)
      }); // And in case the action menu was open, close it.

      this.setActionsOpen(false);
    }
  }, {
    key: "handleAttachmentClick",
    value: function handleAttachmentClick() {
      this.dropzone.open();
    }
  }, {
    key: "handleImagePaste",
    value: function handleImagePaste(e) {
      var _this3 = this;

      // Get the pasted image file
      var files = _toConsumableArray((e.clipboardData || e.originalEvent.clipboardData).items).filter(function (i) {
        return /image/.test(i.type);
      }).map(function (i) {
        return i.getAsFile();
      });

      var notAlreadyAttached = files.filter(function (file) {
        return !_this3.state.fileAttachments.find(function (fa) {
          return fa.name === file.name;
        });
      });

      if (notAlreadyAttached.length > 0) {
        // Add preview property to files
        notAlreadyAttached.forEach(function (f) {
          f.preview = URL.createObjectURL(f);
        }); // Store the pasted image file.

        this.setState({
          fileAttachments: this.state.fileAttachments.concat(notAlreadyAttached)
        });
      }
    }
  }, {
    key: "handleDropzoneRef",
    value: function handleDropzoneRef(dropzone) {
      this.dropzone = dropzone;
    }
  }, {
    key: "toggleActionsOpen",
    value: function toggleActionsOpen() {
      this.setState(function (state) {
        return {
          actionsOpen: !state.actionsOpen
        };
      });
    }
  }, {
    key: "setActionsOpen",
    value: function setActionsOpen(actionsOpen) {
      this.setState({
        actionsOpen: actionsOpen
      });
    }
  }, {
    key: "isChatInputInvalid",
    value: function isChatInputInvalid() {
      return !this.state.chatInput && this.state.fileAttachments.length === 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement(Dropzone, {
        disableClick: true,
        ref: this.handleDropzoneRef,
        onDrop: this.handleAttachmentDrop,
        multiple: true,
        style: {},
        className: "discussion__dropzone"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: this.handleSendChatMessage,
        className: "message-form message-form--default ".concat(this.props.messageActions.editing ? 'is-editing' : '', " ").concat(this.props.messageActions.replying ? 'is-replying' : '')
      }, !this.props.discussion.isArchived && /*#__PURE__*/React.createElement(ButtonDropdown, {
        isOpen: this.state.actionsOpen,
        toggle: this.toggleActionsOpen,
        direction: "up",
        "aria-label": "More discussion options"
      }, /*#__PURE__*/React.createElement(DropdownToggle, {
        color: "subtle" // tabIndex={2}

      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-plus",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, "Add File or Invite Person")), /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement(DropdownItem, {
        onClick: this.handleAttachmentClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-paperclip"
      }), " Add File"), /*#__PURE__*/React.createElement(DropdownItem, {
        onClick: this.props.toggleInvitationForm
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-plus"
      }), " Invite Person"))), /*#__PURE__*/React.createElement(Popover, {
        className: "reply-popover",
        placement: "top-start",
        hideArrow: true,
        isOpen: !!this.props.messageActions.replying,
        target: "chatInput"
      }, this.props.messageActions.replying && /*#__PURE__*/React.createElement(PopoverBody, null, "\u21AA In reply to", ' ', this.props.messageActions.replying.createdBy.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "message-form__input",
        id: "chatInput"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row'
        }
      }, this.state.fileAttachments.map(function (attachment) {
        return /*#__PURE__*/React.createElement(UploadCard, {
          key: attachment.value ? attachment.value.documentId : attachment.name,
          discussion: _this4.props.discussion,
          message: _this4.props.messageActions.editing,
          attachment: attachment,
          remove: _this4.handleAttachmentCancel
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames('message-form__placeholder', {
          'is-hidden': this.state.chatInput !== '' || this.props.discussion.isArchived
        })
      }, "Type your message here\u2026"), !this.props.discussion.isArchived ? /*#__PURE__*/React.createElement(ContentEditable, {
        ref: function ref(element) {
          return _this4.contentEditable = element;
        } // tabIndex={1}
        ,
        tagName: "div",
        className: "message-form__editor",
        contentEditable: "plaintext-only",
        html: this.state.chatInput,
        onChange: this.handleChatInput,
        onKeyPress: this.handleChatHotKey,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onPaste: this.handleImagePaste,
        "aria-label": "Type your message here\u2026"
      }) : /*#__PURE__*/React.createElement("div", {
        className: "message-form__editor is-disabled text-danger"
      }, "This discussion has been archived and is read-only.")), (this.props.messageActions.editing || this.props.messageActions.replying) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-subtle btn-cancel",
        onClick: this.cancelAction,
        "aria-label": "Cancel Discussion Message" // tabIndex={3}

      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-times",
        "aria-hidden": "true"
      })), !this.props.discussion.isArchived && /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "btn btn-subtle btn-send",
        disabled: this.isChatInputInvalid(),
        "aria-label": "Send Discussion Message" // tabIndex={3}

      }, this.props.messageActions.editing ? /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-check",
        "aria-hidden": "true"
      }) : /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-paper-plane",
        "aria-hidden": "true"
      }))), this.state.hasFocus && /*#__PURE__*/React.createElement("div", {
        className: "markdown-help"
      }, /*#__PURE__*/React.createElement("strong", {
        className: "markdown-help__sample"
      }, "**Bold**"), /*#__PURE__*/React.createElement("em", {
        className: "markdown-help__sample"
      }, "_Italics_"), /*#__PURE__*/React.createElement("span", {
        className: "markdown-help__sample"
      }, "~~", /*#__PURE__*/React.createElement("strike", null, "Strike"), "~~"), /*#__PURE__*/React.createElement("span", {
        className: "markdown-help__sample"
      }, ">Blockquote")));
    }
  }]);

  return ChatInput;
}(Component);

export var ConnectedChatInputForm = compose(connect(null))(ChatInput);
export var ChatInputForm = function ChatInputForm(props) {
  return /*#__PURE__*/React.createElement(ConnectedChatInputForm, props);
}; // (
//   <Provider>
//     <ConnectedChatInputForm {...props} />
//   </Provider>
// );